/*
 * Local currency amounts (snippets/local-amount.liquid).
 * Each .local-amount element carries an amount in the shop currency (GBP).
 * For another currency it is converted with Shopify's own rate (Shopify.currency.rate),
 * to the exact amount (Ivan's rule: no rounding to nice numbers; cents are rounded up
 * like the market announcement bar's "exact" option). Whole amounts drop the ".00".
 * Free-delivery amounts (data-kind="threshold") take Shopify's currency conversion fee
 * (data-fx-fee, %) off the rate, because checkout converts them without it.
 */
(function () {
  if (window.__knocLocalAmount) return;
  window.__knocLocalAmount = true;

  var NO_DECIMALS = {
    amount: 'amount_no_decimals',
    amount_with_comma_separator: 'amount_no_decimals_with_comma_separator',
    amount_with_space_separator: 'amount_no_decimals_with_space_separator',
    amount_with_apostrophe_separator: 'amount_no_decimals_with_apostrophe_separator'
  };

  function formatCents(cents, pattern) {
    function delimit(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    return pattern.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, name) {
      if (cents % 100 === 0 && NO_DECIMALS[name]) name = NO_DECIMALS[name];
      switch (name) {
        case 'amount_no_decimals': return delimit(0, ',', '.');
        case 'amount_with_space_separator': return delimit(2, ' ', '.');
        case 'amount_with_comma_separator': return delimit(2, '.', ',');
        case 'amount_with_apostrophe_separator': return delimit(2, "'", '.');
        case 'amount_no_decimals_with_comma_separator': return delimit(0, '.', ',');
        case 'amount_no_decimals_with_space_separator': return delimit(0, ' ', '.');
        case 'amount_no_decimals_with_apostrophe_separator': return delimit(0, "'", '.');
        default: return delimit(2, ',', '.');
      }
    });
  }

  function convert(root) {
    var currency = window.Shopify && window.Shopify.currency;
    if (!currency || !currency.active || !root || !root.querySelectorAll) return;
    var rate = parseFloat(currency.rate) || 1;
    root.querySelectorAll('.local-amount[data-amount]:not([data-converted])').forEach(function (el) {
      var amount = parseFloat(el.dataset.amount);
      if (!(amount >= 0) || !el.dataset.format) return;
      var elRate = rate;
      var fee = el.dataset.kind === 'threshold' ? parseFloat(el.dataset.fxFee) || 0 : 0;
      if (fee > 0) elRate = rate / (1 + fee / 100);
      var value = currency.active === el.dataset.shopCurrency ? amount : amount * elRate;
      var cents = /no_decimals/.test(el.dataset.format) ? Math.ceil(value - 1e-9) * 100 : Math.ceil(value * 100 - 1e-6);
      var box = document.createElement('textarea');
      box.innerHTML = formatCents(cents, el.dataset.format).replace(/<[^>]*>/g, '');
      el.textContent = box.value;
      el.setAttribute('data-converted', currency.active);
      el.classList.remove('local-amount--pending');
      el.style.removeProperty('visibility');
    });
  }

  function init() {
    convert(document);
    if (window.MutationObserver) {
      new MutationObserver(function () { convert(document); }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function (event) { convert(event.target); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
